import React from "react";

import Button from "../../../lib/components/Button";
import EctsInput from "./components/EctsInput";
import Schema from "./StructuredDataSchema.json";

export default function ECTSCalculatorComponent({
  lectureHours,
  selfStudyHours,
  weeks,
  ectsScore,
  setLectureHours,
  setSelfStudyHours,
  setWeeks,
  calculateEcts,
  slug,
  saveUserScore,
  enableSaveButton,
}) {
  return (
    <section className="flex justify-center">
      <script type="application/ld+json">{JSON.stringify(Schema)}</script>
      <section className="flex flex-col items-center px-4 mt-16 space-y-12 max-w-7xl lg:flex-row lg:justify-between lg:px-0 lg:my-16 lg:mx-10 lg:space-y-0 lg:space-x-8 lg:space-x-24">
        {/* left text */}
        <section className="flex flex-col justify-center space-y-4">
          <h1 className="font-serif text-3xl font-extrabold tracking-tight text-secondary">
            ECTS Credits Calculator
          </h1>
          <p className="font-serif text-base font-medium tracking-tight text-secondary-dark-300">
            ECTS Credit Calculator This calculator can be used to calculate the
            equivalent ECTS credits from the number of lecture hours and self
            study hours spent on a particular subject.
          </p>
        </section>

        {/* Right box */}
        <section className="p-8 rounded-2xl border md:p-16 md:w-11/12 w-9/10 drop-shadow-sm filter">
          <section className="space-y-8">
            <section className="space-y-6">
              <div className="space-y-4">
                <EctsInput
                  title="Lecture Hours/Week"
                  value={lectureHours}
                  placeholder={"4"}
                  onChange={(event) => {
                    if (event.target.value >= 0) {
                      setLectureHours(event.target.value);
                    }
                  }}
                />
                <EctsInput
                  title="Self Study Hours/Week"
                  value={selfStudyHours}
                  placeholder={"4"}
                  onChange={(event) => {
                    if (event.target.value >= 0) {
                      setSelfStudyHours(event.target.value);
                    }
                  }}
                />
                <EctsInput
                  title="No. of Weeks/Semester"
                  value={weeks}
                  placeholder={"16"}
                  onChange={(event) => {
                    if (event.target.value >= 0) {
                      setWeeks(event.target.value);
                    }
                  }}
                />
              </div>

              <div className="flex justify-center items-center space-x-1">
                <Button
                  size="responsive-base"
                  label="Convert"
                  block
                  disabled={!Boolean(lectureHours && selfStudyHours && weeks)}
                  onClick={calculateEcts}
                  logImpression={true}
                  logEventProps={{
                    elementName: `convert-button`,
                    eventName: `ects-credits-converted`,
                    slug: slug,
                    credits: { lectureHours, selfStudyHours, weeks },
                  }}
                  customContainerClass={
                    ectsScore == null ? "w-full" : "w-4/5 animate-fade-in"
                  }
                />
                {ectsScore && ectsScore > 0 && (
                  <Button
                    size="responsive-base"
                    label="Save"
                    disabled={!Boolean(enableSaveButton)}
                    variant={"outline-secondary"}
                    customContainerClass="w-1/5 animate-fade-in"
                    onClick={saveUserScore}
                  />
                )}
              </div>
            </section>

            {/* Result */}
            <section className="space-y-6 font-serif text-center">
              <div className="space-y-3">
                <h6 className="text-sm font-medium tracking-tight text-secondary-dark-100">
                  Equivalent ECTS Credits
                </h6>
                <h4 className="text-4xl font-extrabold tracking-tight text-primary">
                  {ectsScore || 0}
                </h4>
              </div>
            </section>
          </section>
        </section>
      </section>
    </section>
  );
}
